// extracted by mini-css-extract-plugin
export default {"container":"CreatingOffer_container__IbJkv","fadeContainer":"CreatingOffer_fadeContainer__Luifo"};